import React, { useState, useEffect } from 'react'
import SewingRepairTable from './SewingRepairTable'
import { getListSewingRepair } from '../../../services/api/3dApi'
import { Link } from 'react-router-dom'
import { Icon, Pagination, Select, Spin, message, AutoComplete, Input } from 'antd'
import { getListBrand, listPartner } from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import UseDebounce from '../../users/helpers/UseDebounce'
import queryString from 'query-string'
import SelectFilterOptions from '../../shared/SelectFilterOptions'

function SewingRepairPage() {
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listSewingRepair, setListSewingRepair] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [errorType, setErrorType] = useState('')
    const [type, setType] = useState([])
    const [pendingAt, setPendingdAt] = useState({})
    const [loading, setLoading] = useState(false)
    const [selectedBatchId, setSelectedBatchId] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [allPartner, setAllPartner] = useState([])
    const [overTime, setOverTime] = useState([])
    const [printPartner, setPrintPartner] = useState('')
    const [sewingPartner, setSewingPartner] = useState('')

    const debounceError = errorType === '' ? UseDebounce(errorType, 0) : UseDebounce(errorType, 500)

    const fetchSewingRepair = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (brand.length) payload.brand_name = brand.join()
            if (!!errorType) payload.type_error = [errorType]
            if (type.length) payload.sku = type
            if (Object.keys(pendingAt).length) {
                payload['sewing_repair_from'] = pendingAt.from
                payload['sewing_repair_to'] = pendingAt.to
            }
            if (!!printPartner) payload.partner = printPartner
            if (!!sewingPartner) payload.sewing_partner = sewingPartner
            if (overTime.length) payload.overtime = overTime

            const { data: res } = await getListSewingRepair(payload)
            const { data, success, message: mess } = { ...res }
            if (success) {
                setListSewingRepair(data.batchitems)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const _getAllPartner = async () => {
        const payload = {
            limit: 10000,
            page: 1,
            hidden: false,
        }
        try {
            const query = queryString.stringify(payload)
            const { data: Data } = await listPartner(query)
            const { data, success, message } = Data
            if (success) {
                setAllPartner(data.partners)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const handleChangeErrorType = (value) => {
        setErrorType(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangePendingAt = (field, value) => {
        setPendingdAt(value)
        setPage(1)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchSewingRepair()
    }, [brand, debounceError, type, pendingAt, limit, page, printPartner, sewingPartner, overTime])

    useEffect(() => {
        _getListBrand()
        _getAllPartner()
    }, [])

    const { Option } = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')

    const options = [
        'Lỗi đường may',
        'Sai kích thước',
        'Đối xứng chi tiết',
        'Không khớp hình',
        'Lỗi mác',
        'Thiếu, nhầm chi tiết',
        'Thiếu đường may',
        'Bục rách',
        'Lỗi lót',
        'Lỗi chân kim',
        'Lỗi khóa',
        'Lệch họng cổ',
    ]
    function _resetSelected() {
        setSelectedAll(false)
        setSelectedBatchId([])
    }
    function _toggleSelectAll(isChecked) {
        if (isChecked) {
            const listIds = []

            listSewingRepair.map(item => listIds.push(item.item._id))

            setSelectedBatchId(listIds)
            setSelectedAll(true)
        } else {
            setSelectedBatchId([])
            setSelectedAll(false)
        }
    }
    function _updateSelectedBatches(id, isAdded) {
        if (isAdded && !selectedBatchId.includes(id)) {
            setSelectedBatchId([...selectedBatchId, id])
            setSelectedAll(selectedBatchId.length + 1 === listSewingRepair.length)
        } else {
            const filtered = selectedBatchId.filter(batch => batch !== id)

            setSelectedBatchId(filtered)
            setSelectedAll(false)
        }
    }

    const getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                Options.push(Option)
            }
        }
        return Options
    }

    const handleChangeOverTime = (field, value) => {
        setOverTime([...value])
    }

    const handleChangePartner = (name, value) => {
        if(name === 'printPartner') {
            setPrintPartner(value)
        }
        if(name === 'sewingPartner') {
            setSewingPartner(value)
        }
    }


    const listPrintPartner = allPartner.filter(i => i.type_partner === 'print_partner')
    const listSewingPartner = allPartner.filter(i => i.type_partner === 'sewing_partner')

    return (
        <div className='SewingRepairPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách item cần sửa may</h3>
                        <div className='d-flex align-items-center'>
                            <Link
                                className='ant-btn ml-3'
                                to='sewing-repair-in-batch'
                                disabled={loading}
                            >
                                Thống kê sửa may
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4 mb-3'>
                                <label className='font-weight-bold d-block'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày báo lỗi</label>
                                <FilterDateRangeV2
                                    field='pending_at'
                                    onDatesChange={handleChangePendingAt}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Loại lỗi:</label>
                                <AutoComplete
                                    options={options}
                                    dataSource={options}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeErrorType}
                                    allowClear
                                    placeholder="Search loại lỗi"
                                    className='w-100'
                                >
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label for="request_update" className="font-weight-bold d-block">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{ width: '100%' }}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                                <SelectFilterOptions
                                    defaultValue={overTime}
                                    listOptions={getOptionOverTime(-6, 6)}
                                    style={{ width: '100%' }}
                                    field="overtime" label="Thời gian item quá hạn"
                                    handleChange={handleChangeOverTime}
                                    mode='multiple'
                                    showArrow
                                    allowClear
                                    placeholder='Chọn thời gian item quá hạn'
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Đối tác in ép</label>
                                <Select
                                    onChange={(value) => handleChangePartner('printPartner', value)}
                                    value = {printPartner || []} 
                                    style={{ width: '100%' }} 
                                    placeholder='Chọn đối tác in ép' 
                                    allowClear
                                >
                                    {
                                        listPrintPartner.length > 0 && listPrintPartner.map(item => {
                                            return <Option key={item._id} value={item._id}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Đối tác may</label>
                                <Select
                                    onChange={(value) => handleChangePartner('sewingPartner', value)}
                                    value={sewingPartner || []} 
                                    style={{ width: '100%' }} 
                                    placeholder='Chọn đối tác may' 
                                    allowClear
                                >
                                    {
                                        listSewingPartner.length > 0 && listSewingPartner.map(item => {
                                            return <Option key={item._id} value={item._id}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <SewingRepairTable
                            listSewingRepair={listSewingRepair}
                            selectedBatchId={selectedBatchId}
                            selectedAll={selectedAll}
                            setType={setType}
                            setBrand={setBrand}
                            onResetSelected={_resetSelected}
                            onSelectAll={_toggleSelectAll}
                            onUpdateSelectedBatches={_updateSelectedBatches}
                            reset={fetchSewingRepair}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default SewingRepairPage